module.exports = __webpack_public_path__ + "img/Landwirt-IK-101-2.2e423c4f.jpg";